import { convertMonth } from '@/helpers/convertMonth'
import { useGetEventsQuery } from '@/redux/services/newsApi'
import classNames from 'classnames'
import moment from 'moment'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import s from './Calendar.module.scss'

const eventsTabs = ['ближайшие события', 'с участием Мегамикс']

const eventsTabsTranslation = ['upcomingEvents', 'featuringMegamix']

const CalendarEvents = ({
    targetDate,
    setTargetDate,
    currentList,
    setCurrentList,
    eventsDefault,
    lightTheme = false
}) => {
    const [currentTab, setCurrentTab] = useState('ближайшие события')
    const { t, i18n } = useTranslation()

    const formatDate = date => {
        const originalDate = moment(date)
        if (i18n.language === 'en') {
            return `${originalDate.format('DD')} ${originalDate.format('MMMM')}`
        }
        return `${originalDate.format('DD')} ${convertMonth(originalDate.format('MMMM'), true)}`
    }

    const changeTab = tab => {
        setCurrentTab(tab)
        changeList(tab)
    }

    const changeList = tab => {
        if (tab === 'ближайшие события') {
            setCurrentList(eventsDefault)
            setTargetDate(null)
        }
        if (tab === 'с участием Мегамикс') {
            setCurrentList(prev => prev?.filter(event => event.withMegamix !== false))
            setTargetDate(null)
        }
    }

    useEffect(() => {
        if (targetDate !== null) {
            setCurrentTab('')
        } else {
            if (currentTab === '') {
                setCurrentTab('ближайшие события')
            }
        }
    }, [targetDate])

    return (
        <div className={`calendar__events-wrapper ${lightTheme ? s.lightWrapper : ''}`}>
            <div className={`calendar__events ${lightTheme ? s.lightWrapper : ''}`}>
                <ul className='calendar__events-head'>
                    {targetDate !== null ? (
                        <li className='calendar__events-tab_chosen'>
                            <p className={classNames(`calendar__events-tab categories-slider__text`)}>
                                {targetDate.format('DD')}.{targetDate.format('MM')}
                            </p>
                        </li>
                    ) : null}
                    {eventsTabs?.map((tab, i) => (
                        <li key={tab}>
                            <p
                                onClick={() => changeTab(tab)}
                                className={`calendar__events-tab ${
                                    currentTab === tab ? 'categories-slider__text' : ''
                                } ${lightTheme ? s.eventsTabLight : ''}`}
                            >
                                {t(eventsTabsTranslation[i])}
                            </p>
                        </li>
                    ))}
                </ul>
                <div className='calendar__events-list-wrapper'>
                    <ul className='calendar__events-list'>
                        {targetDate !== null
                            ? currentList?.map((event, i) => (
                                  <Link
                                      key={i}
                                      target='_blank'
                                      href={`event/${event.translit}`}
                                  >
                                      <li className={`calendar__event calendar__event_open`}>
                                          <div className='calendar__event-head'>
                                              <p className='calendar__event-name_open'>{event.title}</p>
                                              <svg
                                                  width='24'
                                                  height='24'
                                                  viewBox='0 0 24 24'
                                                  fill='none'
                                                  xmlns='http://www.w3.org/2000/svg'
                                              >
                                                  <path
                                                      fillRule='evenodd'
                                                      clipRule='evenodd'
                                                      d='M22.5032 14L22.875 14C23.4273 14 23.875 14.4477 23.875 15V19C23.875 19.5523 23.4273 20 22.875 20C22.3227 20 21.875 19.5523 21.875 19V17.1427L16.7328 22.6805C16.357 23.0852 15.7243 23.1086 15.3196 22.7328C14.9148 22.357 14.8914 21.7243 15.2672 21.3196L20.2068 16H18.5C17.9477 16 17.5 15.5523 17.5 15C17.5 14.4477 17.9477 14 18.5 14L22.4973 14C22.4993 14 22.5012 14 22.5032 14Z'
                                                      fill='#C1CCE2'
                                                  />
                                                  <path
                                                      fillRule='evenodd'
                                                      clipRule='evenodd'
                                                      d='M7.48242 2C7.48242 1.44772 7.03471 1 6.48242 1C5.93014 1 5.48242 1.44772 5.48242 2V3.75879H4.75862C3.76177 3.75879 2.80575 4.15479 2.10087 4.85966C1.396 5.56454 1 6.52056 1 7.51741V19.2416C1 20.2384 1.396 21.1944 2.10087 21.8993C2.80575 22.6042 3.76177 23.0002 4.75862 23.0002H10.9655C11.5178 23.0002 11.9655 22.5525 11.9655 22.0002C11.9655 21.4479 11.5178 21.0002 10.9655 21.0002H4.75862C4.29221 21.0002 3.84489 20.8149 3.51509 20.4851C3.18528 20.1553 3 19.708 3 19.2416V7.51741C3 7.05099 3.18528 6.60368 3.51509 6.27388C3.84489 5.94407 4.29221 5.75879 4.75862 5.75879H5.48242V6.82759C5.48242 7.37987 5.93014 7.82759 6.48242 7.82759C7.03471 7.82759 7.48242 7.37987 7.48242 6.82759V5.75879H16.5176V6.82759C16.5176 7.37987 16.9653 7.82759 17.5176 7.82759C18.0699 7.82759 18.5176 7.37987 18.5176 6.82759V5.75879H19.2414C19.7078 5.75879 20.1551 5.94407 20.4849 6.27388C20.8147 6.60368 21 7.05099 21 7.51741V10.9657C21 11.518 21.4477 11.9657 22 11.9657C22.5523 11.9657 23 11.518 23 10.9657V7.51741C23 6.52056 22.604 5.56454 21.8991 4.85966C21.1942 4.15479 20.2382 3.75879 19.2414 3.75879H18.5176V2C18.5176 1.44772 18.0699 1 17.5176 1C16.9653 1 16.5176 1.44772 16.5176 2V3.75879H7.48242V2ZM6.13782 9.276C5.58553 9.276 5.13782 9.72372 5.13782 10.276C5.13782 10.8283 5.58553 11.276 6.13782 11.276H17.862C18.4142 11.276 18.862 10.8283 18.862 10.276C18.862 9.72372 18.4142 9.276 17.862 9.276H6.13782Z'
                                                      fill='#C1CCE2'
                                                  />
                                              </svg>
                                          </div>
                                          <ul className='calendar__event-details'>
                                              <li className='calendar__event-location'>
                                                  <svg
                                                      width='20'
                                                      height='20'
                                                      viewBox='0 0 20 20'
                                                      fill='none'
                                                      xmlns='http://www.w3.org/2000/svg'
                                                  >
                                                      <path
                                                          d='M17.2 8.37209C17.2 11.0861 15.3891 13.7974 13.4145 15.918C12.4451 16.9591 11.473 17.8189 10.7424 18.4187C10.4499 18.6588 10.1972 18.8565 10 19.0065C9.80285 18.8565 9.55007 18.6588 9.25762 18.4187C8.52696 17.8189 7.55489 16.9591 6.58549 15.918C4.61094 13.7974 2.8 11.0861 2.8 8.37209C2.8 4.15548 6.05744 0.8 10 0.8C13.9426 0.8 17.2 4.15548 17.2 8.37209Z'
                                                          stroke='#7987AC'
                                                          strokeWidth='1.6'
                                                      />
                                                      <circle
                                                          cx='10'
                                                          cy='8'
                                                          r='3.2'
                                                          stroke='#7987AC'
                                                          strokeWidth='1.6'
                                                      />
                                                  </svg>
                                                  <p className='calendar__event-details-text'>{event.location}</p>
                                              </li>
                                              <li className='calendar__event-date_day'>
                                                  <svg
                                                      width='20'
                                                      height='20'
                                                      viewBox='0 0 20 20'
                                                      fill='none'
                                                      xmlns='http://www.w3.org/2000/svg'
                                                  >
                                                      <path
                                                          d='M16 18.0001C17.1046 18.0001 18 17.1047 18 16.0001V6.41393C18 5.82862 17.7675 5.26729 17.3536 4.85342C16.9397 4.43954 16.3784 4.20703 15.7931 4.20703H4.2069C3.62159 4.20703 3.06026 4.43954 2.64638 4.85342C2.23251 5.26729 2 5.82862 2 6.41393V15.7932C2 16.3785 2.23251 16.9399 2.64638 17.3537C3.06026 17.7676 3.62159 18.0001 4.2069 18.0001L16 18.0001Z'
                                                          stroke='#7987AC'
                                                          strokeWidth='1.6'
                                                          strokeLinecap='round'
                                                          strokeLinejoin='round'
                                                      />
                                                      <path
                                                          d='M5.58594 2V5.86207'
                                                          stroke='#7987AC'
                                                          strokeWidth='1.6'
                                                          strokeLinecap='round'
                                                          strokeLinejoin='round'
                                                      />
                                                      <path
                                                          d='M14.4141 2V5.86207'
                                                          stroke='#7987AC'
                                                          strokeWidth='1.6'
                                                          strokeLinecap='round'
                                                          strokeLinejoin='round'
                                                      />
                                                      <path
                                                          d='M5.3103 8.62109H14.6896'
                                                          stroke='#7987AC'
                                                          strokeWidth='1.6'
                                                          strokeLinecap='round'
                                                          strokeLinejoin='round'
                                                      />
                                                  </svg>
                                                  <p className='calendar__event-details-text'>
                                                      {event.dateFrom.toString() === event.dateTo.toString()
                                                          ? formatDate(event.dateFrom)
                                                          : `${formatDate(event.dateFrom)} — ${formatDate(
                                                                event.dateTo
                                                            )}`}
                                                  </p>
                                              </li>
                                              <li className='calendar__event-link'>
                                                  <svg
                                                      className='calendar__event-sphera'
                                                      width='20'
                                                      height='20'
                                                      viewBox='0 0 20 20'
                                                      fill='none'
                                                      xmlns='http://www.w3.org/2000/svg'
                                                  >
                                                      <circle
                                                          cx='10'
                                                          cy='10'
                                                          r='9.2'
                                                          stroke='#FFAC6A'
                                                          strokeWidth='1.6'
                                                      />
                                                      <path
                                                          d='M13.2 10C13.2 12.6857 12.7631 15.0803 12.0856 16.774C11.746 17.623 11.3616 18.2564 10.9757 18.6645C10.5914 19.0708 10.2614 19.2 10 19.2C9.73857 19.2 9.40857 19.0708 9.02426 18.6645C8.63836 18.2564 8.25397 17.623 7.91435 16.774C7.2369 15.0803 6.8 12.6857 6.8 10C6.8 7.3143 7.2369 4.91969 7.91435 3.22604C8.25397 2.377 8.63836 1.7436 9.02426 1.33554C9.40857 0.929164 9.73857 0.8 10 0.8C10.2614 0.8 10.5914 0.929164 10.9757 1.33554C11.3616 1.7436 11.746 2.377 12.0856 3.22604C12.7631 4.91969 13.2 7.3143 13.2 10Z'
                                                          stroke='#FFAC6A'
                                                          strokeWidth='1.6'
                                                      />
                                                      <line
                                                          x1='1'
                                                          y1='10.2'
                                                          x2='19'
                                                          y2='10.2'
                                                          stroke='#FFAC6A'
                                                          strokeWidth='1.6'
                                                      />
                                                  </svg>
                                                  <Link
                                                      target='_blank'
                                                      href={event.link}
                                                  >
                                                      <p className='calendar__event-details-text'>
                                                          {event.link.replace('https://', '')}
                                                      </p>
                                                      <svg
                                                          width='8'
                                                          height='8'
                                                          viewBox='0 0 8 8'
                                                          fill='none'
                                                          xmlns='http://www.w3.org/2000/svg'
                                                      >
                                                          <path
                                                              d='M7.25685 1.00037C7.25685 0.669001 6.98823 0.400372 6.65685 0.400372L1.25685 0.400372C0.925483 0.400372 0.656854 0.669001 0.656854 1.00037C0.656854 1.33174 0.925483 1.60037 1.25685 1.60037L6.05685 1.60037L6.05685 6.40037C6.05685 6.73174 6.32548 7.00037 6.65685 7.00037C6.98823 7.00037 7.25685 6.73174 7.25685 6.40037L7.25685 1.00037ZM0.575736 6.23296C0.341421 6.46728 0.341421 6.84718 0.575736 7.08149C0.810051 7.31581 1.18995 7.31581 1.42426 7.08149L0.575736 6.23296ZM1.42426 7.08149L7.08112 1.42464L6.23259 0.576108L0.575736 6.23296L1.42426 7.08149Z'
                                                              fill='#FF727E'
                                                          />
                                                      </svg>
                                                  </Link>
                                              </li>
                                          </ul>
                                      </li>
                                  </Link>
                              ))
                            : currentList?.map((event, i) => {
                                  if (event.dateTo > new Date()) {
                                      return (
                                          <Link
                                              key={i}
                                              target='_blank'
                                              href={`event/${event.translit}`}
                                          >
                                              <li
                                                  key={event.id}
                                                  className={`calendar__event`}
                                              >
                                                  <div
                                                      className={classNames(
                                                          'calendar__event-head',
                                                          lightTheme ? s.calendarHead : ''
                                                      )}
                                                  >
                                                      <div className='calendar__event-date-block'>
                                                          {event.dateFrom.toString() === event.dateTo.toString() ? (
                                                              <p
                                                                  className={classNames(
                                                                      'calendar__event-date',
                                                                      lightTheme ? s.lightEventDate : ''
                                                                  )}
                                                              >
                                                                  {formatDate(event.dateFrom).toLowerCase()}
                                                              </p>
                                                          ) : (
                                                              <>
                                                                  <p
                                                                      className={classNames(
                                                                          'calendar__event-date',
                                                                          lightTheme ? s.lightEventDate : ''
                                                                      )}
                                                                  >
                                                                      {formatDate(event.dateFrom).toLowerCase()} —&nbsp;
                                                                  </p>
                                                                  <p
                                                                      className={classNames(
                                                                          'calendar__event-date',
                                                                          lightTheme ? s.lightEventDate : ''
                                                                      )}
                                                                  >
                                                                      {formatDate(event.dateTo).toLowerCase()}
                                                                  </p>
                                                              </>
                                                          )}
                                                      </div>
                                                      {/* <p className="calendar__event-date">{  : `${formatDate(event.dateFrom).toLowerCase()} —\n ${formatDate(event.dateTo).toLowerCase()}`}</p> */}
                                                      <p
                                                          className={classNames(
                                                              'calendar__event-name',
                                                              lightTheme ? s.eventNameLight : ''
                                                          )}
                                                      >
                                                          {event.title}
                                                      </p>
                                                      <svg
                                                          width='24'
                                                          height='24'
                                                          viewBox='0 0 24 24'
                                                          fill='none'
                                                          xmlns='http://www.w3.org/2000/svg'
                                                      >
                                                          <path
                                                              fillRule='evenodd'
                                                              clipRule='evenodd'
                                                              d='M22.5032 14L22.875 14C23.4273 14 23.875 14.4477 23.875 15V19C23.875 19.5523 23.4273 20 22.875 20C22.3227 20 21.875 19.5523 21.875 19V17.1427L16.7328 22.6805C16.357 23.0852 15.7243 23.1086 15.3196 22.7328C14.9148 22.357 14.8914 21.7243 15.2672 21.3196L20.2068 16H18.5C17.9477 16 17.5 15.5523 17.5 15C17.5 14.4477 17.9477 14 18.5 14L22.4973 14C22.4993 14 22.5012 14 22.5032 14Z'
                                                              fill='#C1CCE2'
                                                          />
                                                          <path
                                                              fillRule='evenodd'
                                                              clipRule='evenodd'
                                                              d='M7.48242 2C7.48242 1.44772 7.03471 1 6.48242 1C5.93014 1 5.48242 1.44772 5.48242 2V3.75879H4.75862C3.76177 3.75879 2.80575 4.15479 2.10087 4.85966C1.396 5.56454 1 6.52056 1 7.51741V19.2416C1 20.2384 1.396 21.1944 2.10087 21.8993C2.80575 22.6042 3.76177 23.0002 4.75862 23.0002H10.9655C11.5178 23.0002 11.9655 22.5525 11.9655 22.0002C11.9655 21.4479 11.5178 21.0002 10.9655 21.0002H4.75862C4.29221 21.0002 3.84489 20.8149 3.51509 20.4851C3.18528 20.1553 3 19.708 3 19.2416V7.51741C3 7.05099 3.18528 6.60368 3.51509 6.27388C3.84489 5.94407 4.29221 5.75879 4.75862 5.75879H5.48242V6.82759C5.48242 7.37987 5.93014 7.82759 6.48242 7.82759C7.03471 7.82759 7.48242 7.37987 7.48242 6.82759V5.75879H16.5176V6.82759C16.5176 7.37987 16.9653 7.82759 17.5176 7.82759C18.0699 7.82759 18.5176 7.37987 18.5176 6.82759V5.75879H19.2414C19.7078 5.75879 20.1551 5.94407 20.4849 6.27388C20.8147 6.60368 21 7.05099 21 7.51741V10.9657C21 11.518 21.4477 11.9657 22 11.9657C22.5523 11.9657 23 11.518 23 10.9657V7.51741C23 6.52056 22.604 5.56454 21.8991 4.85966C21.1942 4.15479 20.2382 3.75879 19.2414 3.75879H18.5176V2C18.5176 1.44772 18.0699 1 17.5176 1C16.9653 1 16.5176 1.44772 16.5176 2V3.75879H7.48242V2ZM6.13782 9.276C5.58553 9.276 5.13782 9.72372 5.13782 10.276C5.13782 10.8283 5.58553 11.276 6.13782 11.276H17.862C18.4142 11.276 18.862 10.8283 18.862 10.276C18.862 9.72372 18.4142 9.276 17.862 9.276H6.13782Z'
                                                              fill='#C1CCE2'
                                                          />
                                                      </svg>
                                                  </div>
                                                  <div className='calendar__event-details'>
                                                      <div className='calendar__event-location'>
                                                          <svg
                                                              width='20'
                                                              height='20'
                                                              viewBox='0 0 20 20'
                                                              fill='none'
                                                              xmlns='http://www.w3.org/2000/svg'
                                                          >
                                                              <path
                                                                  d='M17.2 8.37209C17.2 11.0861 15.3891 13.7974 13.4145 15.918C12.4451 16.9591 11.473 17.8189 10.7424 18.4187C10.4499 18.6588 10.1972 18.8565 10 19.0065C9.80285 18.8565 9.55007 18.6588 9.25762 18.4187C8.52696 17.8189 7.55489 16.9591 6.58549 15.918C4.61094 13.7974 2.8 11.0861 2.8 8.37209C2.8 4.15548 6.05744 0.8 10 0.8C13.9426 0.8 17.2 4.15548 17.2 8.37209Z'
                                                                  stroke='#7987AC'
                                                                  strokeWidth='1.6'
                                                              />
                                                              <circle
                                                                  cx='10'
                                                                  cy='8'
                                                                  r='3.2'
                                                                  stroke='#7987AC'
                                                                  strokeWidth='1.6'
                                                              />
                                                          </svg>
                                                          <p className='calendar__event-details-text'>
                                                              {event.location}
                                                          </p>
                                                      </div>
                                                      <div className='calendar__event-date_day'>
                                                          <svg
                                                              width='20'
                                                              height='20'
                                                              viewBox='0 0 20 20'
                                                              fill='none'
                                                              xmlns='http://www.w3.org/2000/svg'
                                                          >
                                                              <path
                                                                  d='M16 18.0001C17.1046 18.0001 18 17.1047 18 16.0001V6.41393C18 5.82862 17.7675 5.26729 17.3536 4.85342C16.9397 4.43954 16.3784 4.20703 15.7931 4.20703H4.2069C3.62159 4.20703 3.06026 4.43954 2.64638 4.85342C2.23251 5.26729 2 5.82862 2 6.41393V15.7932C2 16.3785 2.23251 16.9399 2.64638 17.3537C3.06026 17.7676 3.62159 18.0001 4.2069 18.0001L16 18.0001Z'
                                                                  stroke='#7987AC'
                                                                  strokeWidth='1.6'
                                                                  strokeLinecap='round'
                                                                  strokeLinejoin='round'
                                                              />
                                                              <path
                                                                  d='M5.58594 2V5.86207'
                                                                  stroke='#7987AC'
                                                                  strokeWidth='1.6'
                                                                  strokeLinecap='round'
                                                                  strokeLinejoin='round'
                                                              />
                                                              <path
                                                                  d='M14.4141 2V5.86207'
                                                                  stroke='#7987AC'
                                                                  strokeWidth='1.6'
                                                                  strokeLinecap='round'
                                                                  strokeLinejoin='round'
                                                              />
                                                              <path
                                                                  d='M5.3103 8.62109H14.6896'
                                                                  stroke='#7987AC'
                                                                  strokeWidth='1.6'
                                                                  strokeLinecap='round'
                                                                  strokeLinejoin='round'
                                                              />
                                                          </svg>
                                                          <p className='calendar__event-details-text'>
                                                              {event.dateFrom.toString() === event.dateTo.toString()
                                                                  ? formatDate(event.dateFrom)
                                                                  : `${formatDate(event.dateFrom)} — ${formatDate(
                                                                        event.dateTo
                                                                    )}`}
                                                          </p>
                                                      </div>
                                                      <div className='calendar__event-link'>
                                                          <svg
                                                              width='20'
                                                              height='20'
                                                              viewBox='0 0 20 20'
                                                              fill='none'
                                                              xmlns='http://www.w3.org/2000/svg'
                                                          >
                                                              <circle
                                                                  cx='10'
                                                                  cy='10'
                                                                  r='9.2'
                                                                  stroke='#FFAC6A'
                                                                  strokeWidth='1.6'
                                                              />
                                                              <path
                                                                  d='M13.2 10C13.2 12.6857 12.7631 15.0803 12.0856 16.774C11.746 17.623 11.3616 18.2564 10.9757 18.6645C10.5914 19.0708 10.2614 19.2 10 19.2C9.73857 19.2 9.40857 19.0708 9.02426 18.6645C8.63836 18.2564 8.25397 17.623 7.91435 16.774C7.2369 15.0803 6.8 12.6857 6.8 10C6.8 7.3143 7.2369 4.91969 7.91435 3.22604C8.25397 2.377 8.63836 1.7436 9.02426 1.33554C9.40857 0.929164 9.73857 0.8 10 0.8C10.2614 0.8 10.5914 0.929164 10.9757 1.33554C11.3616 1.7436 11.746 2.377 12.0856 3.22604C12.7631 4.91969 13.2 7.3143 13.2 10Z'
                                                                  stroke='#FFAC6A'
                                                                  strokeWidth='1.6'
                                                              />
                                                              <line
                                                                  x1='1'
                                                                  y1='10.2'
                                                                  x2='19'
                                                                  y2='10.2'
                                                                  stroke='#FFAC6A'
                                                                  strokeWidth='1.6'
                                                              />
                                                          </svg>
                                                          <Link href={event.link}>
                                                              <p className='calendar__event-details-text'>
                                                                  {event.link.replace('https://', 'www.')}
                                                              </p>
                                                          </Link>
                                                      </div>
                                                  </div>
                                              </li>
                                          </Link>
                                      )
                                  }
                              })}
                    </ul>
                </div>
            </div>
            {/* <button className="calendar__events-button">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 16V4C2 2.89543 2.89543 2 4 2H16C17.1046 2 18 2.89543 18 4V16C18 17.1046 17.1046 18 16 18H4C2.89543 18 2 17.1046 2 16Z" stroke="#7987AC" stroke-width="1.6" />
                    <path d="M6 7H14" stroke="#7987AC" stroke-width="1.6" stroke-linecap="round" />
                    <path d="M6 10H14" stroke="#7987AC" stroke-width="1.6" stroke-linecap="round" />
                    <path d="M6 13H14" stroke="#7987AC" stroke-width="1.6" stroke-linecap="round" />
                </svg>
                <p>Смотреть все события</p>
            </button> */}
        </div>
    )
}

export default CalendarEvents
